import request from '@/utils/request'

const passportApi = process.env.VUE_APP_PASSPORT_API
const biddogApi = process.env.VUE_APP_BIDDOG_API

// 用户登录状态验证
export function checkLoginApi() {
  return request({
    url: passportApi + '/passport/status',
    method: 'get'
  })
}

// 退出登录
export function logoutApi() {
  return request({
    url: passportApi + '/logout',
    method: 'post'
  })
}

// 获取基本设置信息
export function getUserBasicApi() {
  return request({
    url: passportApi + '/users/oneself',
    method: 'get'
  })
}

// 获取绑定微信二维码
export function getBindWechatQrCodeApi() {
  return request(
    {
      url: passportApi + '/users/oneself/wx/mp/bind/qr-code',
      method: 'get'
    },
    {
      needLoading: false
    }
  )
}

// 获取灰度信息
export function queryBiddogGrayReleaseApi() {
  return request({
    url: biddogApi + `/biddog/gray-release`,
    method: 'get'
  })
}
